import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 16 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Adminstration_Menu",
    transform: "translate(-47.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_users",
    transform: "translate(47.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,8 C10.5976809,8 11.9036609,9.24891996 11.9949073,10.8237272 L12,11 L12,15 L4,15 L4,11 C4,9.34314575 5.34314575,8 7,8 L9,8 Z M13.75,6 C14.9482607,6 15.9277457,7.04076664 15.9961805,8.35310601 L16,8.5 L16,12 L12.999,12 L13,11 L12.9939392,10.7948483 L12.9747645,10.5853062 C12.7949887,9.08363568 11.7285851,7.84688037 10.2761525,7.30197721 C10.6567295,6.5260865 11.3980714,6 12.25,6 L13.75,6 Z M3.75,6 C4.6019286,6 5.34327053,6.5260865 5.72384751,7.30197721 C4.27141493,7.84688037 3.20501126,9.08363568 3.02523548,10.5853062 L3.02523548,10.5853062 L3.00606075,10.7948483 L3,11 L3,12 L-1.15463195e-14,12 L-1.15463195e-14,8.5 L0.00381952006,8.35310601 C0.0722543404,7.04076664 1.05173934,6 2.25,6 L2.25,6 Z M8,3 C9.1045695,3 10,3.8954305 10,5 C10,6.0543618 9.18412221,6.91816512 8.14926234,6.99451426 L8,7 C6.8954305,7 6,6.1045695 6,5 C6,3.9456382 6.81587779,3.08183488 7.85073766,3.00548574 L8,3 Z M13,1 C14.1045695,1 15,1.8954305 15,3 C15,4.1045695 14.1045695,5 13,5 C11.8954305,5 11,4.1045695 11,3 C11,1.8954305 11.8954305,1 13,1 Z M3,1 C4.1045695,1 5,1.8954305 5,3 C5,4.1045695 4.1045695,5 3,5 C1.8954305,5 1,4.1045695 1,3 C1,1.8954305 1.8954305,1 3,1 Z",
    id: "icon_user",
    fillRule: "nonzero"
  })))))));
});